import {DataHelper} from './data.helper';
import {PeriodTypeEnum} from '../models/period-type.enum';

export class DateHelper {
  public static isToday = (date: Date): boolean => {
    if (!DataHelper.hasValue(date)) {
      return false;
    }
    const today: Date = new Date();
    return date.toDateString() === today.toDateString();
  }

  public static setEndOfDay = (date: Date) => {
    if (!DataHelper.hasValue(date)) {
      return;
    }
    date.setHours(23, 59, 59);
    date.setMilliseconds(999);
  }

  public static setStartOfDay = (date: Date) => {
    if (!DataHelper.hasValue(date)) {
      return;
    }
    date.setHours(0, 0, 0);
    date.setMilliseconds(0);
    return date;
  }

  public static setCurrentTime = (date: Date) => {
    if (!DataHelper.hasValue(date)) {
      return;
    }
    const today: Date = new Date();
    date.setHours(today.getHours(), today.getMinutes(), today.getSeconds());
    date.setMilliseconds(today.getMilliseconds());
  }

  public static timeStringToObject(time: string) {
    const [hour = 0, minute = 0, second = 0] = time.split(':');
    return {hour: Number(hour), minute: Number(minute), second: Number(second)};
  }

  public static setPeriodType(dateFrom: Date, dateTo: Date): PeriodTypeEnum {
    if (dateFrom.getDay() === dateTo.getDay()) {
      return PeriodTypeEnum.Hourly;
    } else if (dateFrom.getDay() !== dateTo.getDay() && dateFrom.getMonth() === dateTo.getMonth()) {
      return PeriodTypeEnum.Daily;
    } else if (dateFrom.getMonth() !== dateTo.getMonth()) {
      return PeriodTypeEnum.Monthly;
    }
    return PeriodTypeEnum.None;
  }
}
